<template>
    <div @click="goToTop" class="go-to-top" style="cursor: pointer;">
        <div><img src="@/assets/icons/arrow-up.svg" /></div>
        <div class="pb-navigation colour-primary-02">Go to Top</div>
    </div>
</template>

<script>

export default {
  data() {
    return {

    }
  },
  methods: {
    goToTop(){
      window.scrollTo({
        top: 0, 
        behavior: 'smooth',
      });
    }
  }
}

</script>

<style lang="scss" scoped>

  @media (min-width: 1661px) {
    .pb-navigation {
      margin-top: 0.5rem;
    }
  }

    
  .go-to-top {
    width: 114px;
    margin-right: 9rem;
    z-index: 1;
  }

  @media (max-width: 1290px) and (min-width: 1024px) {

  }

  @media (max-width: 1023px) {
    .go-to-top {
      margin-right: 0;
    }
  }

  @media (max-width: 768px){
  }
</style>
